import { render, staticRenderFns } from "./manage-permitting.vue?vue&type=template&id=8c0f1fa8&scoped=true"
import script from "./manage-permitting.vue?vue&type=script&lang=js"
export * from "./manage-permitting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0f1fa8",
  null
  
)

export default component.exports